(function () {
  const popup = document.getElementById('ipax-vip-popup');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'ipax-vip-popup-dismissed';
  const delay = Number(popup.dataset.delay || 800);

  const open = () => {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.body.classList.add('ipax-vip-popup-open');
  };

  const close = (persist = true) => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    popup.hidden = true;
    document.body.classList.remove('ipax-vip-popup-open');
    if (persist) {
      try {
        localStorage.setItem(storageKey, '1');
      } catch (error) {
        /* ignore */
      }
    }
  };

  const shouldShow = () => {
    try {
      return localStorage.getItem(storageKey) !== '1';
    } catch (error) {
      return true;
    }
  };

  popup.querySelectorAll('[data-ipax-vip-dismiss]').forEach((el) => {
    el.addEventListener('click', () => close(true));
  });

  popup.querySelectorAll('[data-ipax-vip-join]').forEach((el) => {
    el.addEventListener('click', () => close(true));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      close(true);
    }
  });

  if (shouldShow()) {
    window.setTimeout(open, Math.max(0, delay));
  }
})();
